var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("VerDetallePersona"),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.closeFilterSlide()
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("filter_list")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v("Búsqueda/filtros")])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-tooltip",
                    { attrs: { bottom: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-refresh",
                          attrs: { slot: "activator" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.actualizaLista(0, 1)
                            }
                          },
                          slot: "activator"
                        },
                        [_c("v-icon", [_vm._v("refresh")])],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-card-text",
                    { staticClass: "p-0 mb-2" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("transition", { attrs: { name: "slide-fade" } }, [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.filterShow,
                                    expression: "filterShow"
                                  }
                                ],
                                staticClass: "filter-container"
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "primary" } },
                                  [_vm._v("search")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "CI",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.nro_doc,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "nro_doc",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.nro_doc"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "Ap paterno",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.ap_paterno,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "ap_paterno",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.ap_paterno"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "Ap materno",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.ap_materno,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "ap_materno",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.ap_materno"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "Nombres",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.nombres,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "nombres",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.nombres"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "Nro item",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.nro_item,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "nro_item",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.nro_item"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "Cargo",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.cargo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "cargo",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.cargo"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "text-field-reducido",
                                      attrs: {
                                        label: "Puesto",
                                        type: "text",
                                        clearable: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.puesto,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "puesto",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.puesto"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "filter-item" },
                                  [
                                    _c("v-autocomplete", {
                                      attrs: {
                                        items: _vm.l_unidades,
                                        "item-value": function(v) {
                                          return v.nombre_unidad
                                        },
                                        "item-text": "nombre_unidad",
                                        label: "Tipo de activo",
                                        clearable: ""
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.actualizaLista(0, 1)
                                        }
                                      },
                                      model: {
                                        value: _vm.filter_slide.nombre_unidad,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter_slide,
                                            "nombre_unidad",
                                            $$v
                                          )
                                        },
                                        expression: "filter_slide.nombre_unidad"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "btn-filter" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      { attrs: { bottom: "" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              slot: "activator",
                                              icon: ""
                                            },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.closeFilterSlide()
                                              }
                                            },
                                            slot: "activator"
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("close")]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Cerrar filtros")])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-progress-linear", {
            attrs: { indeterminate: _vm.loading, height: "2" }
          }),
          _vm._v(" "),
          _vm.vec_frame.length > 0
            ? _c(
                "v-layout",
                {
                  staticClass: "justify-space-between",
                  attrs: { row: "", wrap: "" }
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-left px-2",
                      attrs: { xs4: "", "align-self-center": "" }
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "font-weight-light blue--text m-0" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s("TOTAL PERSONAS: " + _vm.total_items) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { shrink: "", "align-self-center": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.page <= 1
                          },
                          on: {
                            click: function($event) {
                              return _vm.actualizaLista(-1)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "3em" },
                              attrs: { color: "blue" }
                            },
                            [_vm._v("\n            chevron_left\n          ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.total_paginas <= _vm.page
                          },
                          on: {
                            click: function($event) {
                              return _vm.actualizaLista(1)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "3em" },
                              attrs: { color: "blue" }
                            },
                            [_vm._v("\n            chevron_right\n          ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-right px-2",
                      attrs: { xs4: "", "align-self-center": "" }
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "font-weight-light blue--text m-0" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                "PAGINA " + this.page + "/" + _vm.total_paginas
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        _vm._l(_vm.vec_frame, function(element) {
                          return _c(
                            "v-flex",
                            {
                              key: element.id_persona,
                              staticClass: "p-0",
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md3: "",
                                lg2: "",
                                xl2: ""
                              }
                            },
                            [
                              _c("ItemSliderComponent", {
                                key: element.id_persona,
                                attrs: { persona: element, id: "content-card" }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-left px-2",
                      attrs: { xs4: "", "align-self-center": "" }
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "font-weight-light blue--text m-0" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s("TOTAL PERSONAS: " + _vm.total_items) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { shrink: "", "align-self-center": "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.page <= 1
                          },
                          on: {
                            click: function($event) {
                              return _vm.actualizaLista(-1)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "3em" },
                              attrs: { color: "blue" }
                            },
                            [_vm._v("\n            chevron_left\n          ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            large: "",
                            disabled: _vm.total_paginas <= _vm.page
                          },
                          on: {
                            click: function($event) {
                              return _vm.actualizaLista(1)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "font-size": "3em" },
                              attrs: { color: "blue" }
                            },
                            [_vm._v("\n            chevron_right\n          ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-right px-2",
                      attrs: { xs4: "", "align-self-center": "" }
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "font-weight-light blue--text m-0" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                "PAGINA " + this.page + "/" + _vm.total_paginas
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _c(
                "v-layout",
                [
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-weight-light grey--text title mb-2 text-xs-center py-3"
                      },
                      [
                        _vm._v(
                          "\n          No se encontraron registros\n        "
                        )
                      ]
                    )
                  ])
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcaa4b6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcaa4b6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/reportes_lista_personal/components/SliderPersonas.vue
// module id = null
// module chunks = 